import React, { useRef, useEffect, useState } from 'react';
import { get } from 'lodash';
import { Tooltip } from 'doraemon';

/*
  根据宽度判断是否需要tooltip
*/
export default (props) => {
  const { style = {}, children } = props;
  const text = useRef();
  const [showTooltip, setShowTooltip] = useState(false);
  const fn = () => {
    const width = get(String(style.width).match(/[0-9]+/),'[0]');
    const maxWidth = get(String(style.maxWidth).match(/[0-9]+/),'[0]');
    const shouldshow =
    get(text, 'current.offsetWidth') < width || get(text, 'current.offsetWidth') < maxWidth;
    setShowTooltip(!shouldshow);
  };
  useEffect(fn, []);
  return showTooltip ? (
    <Tooltip title={ children }>
      <span
        ref={ text }
        style={ {
          textOverflow: 'ellipsis',
          display: 'block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          ...style,
        } }
      >
        {children}
      </span>
    </Tooltip>
  ) : (
    /**
     * whiteSpace: 'nowrap'
     * 表格有固定列渲染列表时，固定列单元格的高度会根据未折叠的高度渲染
     * 通过offsetWidth计算后Tooltip单元格高度变化不会重新渲染固定列单元格样式
     * 此处默认处理单元格不换行
     */
    <span ref={ text } style={ { ...style, whiteSpace: 'nowrap' } }>
      {children}
    </span>
  );
};
